import { render, staticRenderFns } from "./BaseSelectBodyPart.vue?vue&type=template&id=fae7a8ac"
import script from "./BaseSelectBodyPart.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSelectBodyPart.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports